import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Dashboard = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20 19.0001V10.9076C20 10.3309 19.751 9.78222 19.317 9.40244L13.317 4.15244C12.563 3.49265 11.437 3.49265 10.683 4.15244L4.68299 9.40244C4.24896 9.78222 4 10.3309 4 10.9076V19.0001C4 20.1046 4.89543 21.0001 6 21.0001H9C9.55228 21.0001 10 20.5523 10 20.0001V17.0001C10 15.8955 10.8954 15.0001 12 15.0001C13.1046 15.0001 14 15.8955 14 17.0001V20.0001C14 20.5523 14.4477 21.0001 15 21.0001H18C19.1046 21.0001 20 20.1046 20 19.0001Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.8109 3.41805C12.7741 2.52732 11.2259 2.52732 10.1891 3.41805L4.18911 8.57263C3.59232 9.08533 3.25 9.82602 3.25 10.6046V18.55C3.25 20.0412 4.48122 21.25 6 21.25H9C9.9665 21.25 10.75 20.4807 10.75 19.5318V16.5863C10.75 15.9085 11.3096 15.3591 12 15.3591C12.6904 15.3591 13.25 15.9085 13.25 16.5863V19.5318C13.25 20.4807 14.0335 21.25 15 21.25H18C19.5188 21.25 20.75 20.0412 20.75 18.55V10.6046C20.75 9.82602 20.4077 9.08533 19.8109 8.57263L13.8109 3.41805Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
